var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.config.InnerStyle)},[_c('div',{staticClass:"line2"},[_vm._v(_vm._s(_vm.TextValue || _vm.value)+_vm._s(_vm.config.BackStyle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }